<template>
  <v-overlay :value="sharePopup">
    <v-card width="300" style="display: flex">
      <v-overlay :value="createLinkLoader">
        <div v-if="createLinkLoader" class="createLink-loader-state">
          <v-progress-circular indeterminate color="primary" style="align-self: center" />
        </div>
      </v-overlay>
      <v-col style="background-color: white">
        <span class="share-profile">Share Profile</span>
        <v-radio-group :dark="darkRadioGroup" v-model="shareOption">
          <template v-slot:label>
            <div class="chose-format">CHOOSE FORMAT</div>
          </template>
          <!--              <v-radio value="24h" color="#2196F3">-->
          <!--                <template v-slot:label>-->
          <!--                  <div class="share-profile">24 Hour Link</div>-->
          <!--                </template>-->
          <!--              </v-radio>-->
          <v-radio value="permanent" color="#2196F3">
            <template v-slot:label>
              <div class="share-profile">Permanent Link</div>
            </template>
          </v-radio>
        </v-radio-group>
        <!--          </v-form>-->
        <v-divider style="background-color: lightgrey"></v-divider>
        <div class="bottom-buttons-container">
          <v-spacer />
          <v-btn color="#1A73EB" text @click="$emit('shareOptionClicked')" class="bottom-buttons">
            Cancel
          </v-btn>
          <v-btn color="#1A73EB" class="bottom-buttons" text @click="createShareEverythingLink">
            OK
          </v-btn>
        </div>
      </v-col>
    </v-card>
  </v-overlay>
</template>

<script>
import { User, Shares, AppURL } from '@ciitizen/api'

export default {
  name: 'sharingLink',
  data() {
    return {
      sharePopup: true,
      createLinkLoader: false,
      darkRadioGroup: true,
      shareOption: 'permanent' // this will check if is sharing is for "24h" hours or permanent ""
    }
  },
  props: {
    userEmail: {
      type: String,
      default: ''
    },
    userName: {
      type: String,
      default: ''
    },
    userId: {
      type: String,
      default: ''
    }
  },
  async mounted() {
    if (this.userEmail.length || this.userName.length) {
      this.createShareEverythingLink()
    } else {
      await this.fetchUserProfile()
    }
  },
  methods: {
    shareEverythingPayload() {
      const index = this.userEmail.indexOf('@')
      this.userEmail = this.userEmail.split('')
      this.userEmail.splice(index, 0, `+everything`)
      this.userEmail = this.userEmail.join('')
      this.createLinkLoader = true
      const payload = {
        subject: this.userEmail,
        sharingType: 'external_email',
        status: 'pending',
        sharingResources: [
          {
            resourceType: '*',
            permissions: ['read']
          }
        ]
        // expiresIn: this.form.shareOption === "24h" ? "24h" : null,
      }
      return payload
    },
    async createShareEverythingLink() {
      if (this.userEmail.length) {
        const payload = this.shareEverythingPayload()
        if (payload) {
          try {
            const response = await Shares.createExternalShareLink(payload)
            this.shareViaWebShare(response.sharingId)
          } catch (err) {
            console.error(err)
            throw err
          } finally {
            this.shareOptionWorkDone()
          }
        }
      }
    },
    async fetchUserProfile() {
      if (this.userId.length) {
        try {
          const data = await User.getUserProfile(this.userId)
          if (data) {
            this.userEmail = data.profile.email
            this.userName = data.patient.name.first + ' ' + data.patient.name.last
          }
        } catch (err) {
          console.error(err)
          throw err
        }
      }
    },
    shareOptionWorkDone() {
      this.createLinkLoader = false
      this.$emit('shareOptionClicked')
    },
    shareViaWebShare(sharingId) {
      const link =  AppURL.appURL+ '/s/' + sharingId
      if (navigator.share && link) {
        try {
          navigator.share({
            url: link,
            text: this.userName + "'s Ciitizen profile"
          })
        } catch (e) {
          console.error(e)
        }
      } else {
        console.error('Sharing not supported by brower')
      }
    }
  }
}
</script>

<style scoped>
.bottom-buttons-container {
  margin: 20px 0 10px 0;
  display: flex;
}

.bottom-buttons {
  text-align: center;
  color: #1a73eb;
  font-family: Lato;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.25px;
}

.createLink-loader-state {
  display: flex;
  align-self: center;
  width: 100%;
  height: 300px;
  color: #047be3;
  background-color: transparent !important;
  padding: 130px;
  z-index: 3;
}

.share-profile {
  display: flex;
  weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #202124;
}
.chose-format {
  font-family: Lato;
  font-weight: 500;
  font-style: normal;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.8px;
  color: #5f6368;
}
</style>
